import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2 gap-2 bg-trader-dark-gray dark:bg-trader-gray flex overflow-hidden" }



// Define props

export default /*@__PURE__*/_defineComponent({
  __name: 'TRToolbar',
  props: {
    title: {},
    scrollable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})